<template>
  <div style="background-color: #f5f6fb">
    <header class="header">
      <div class="logo-text">
        “AI+VR” 教育大模型
      </div>
    </header>
    <div class="container">
      <!-- 左侧菜单栏 -->
      <div style="width: 70px" v-if="!isSidebarOpen">
        <button @click="toggleSidebar" class="sidebar-toggle">
          <img
            src="@/assets/icons/open-icon.png"
            alt="切换科目"
            class="toggle-icon-open"
          />
        </button>
      </div>
      <aside class="sidebar" :class="{ 'sidebar-collapsed':!isSidebarOpen }">
          <div class="sidebar-header">
            <h3 class="sidebar-title">科目</h3>
            <button @click="toggleSidebar" class="sidebar-toggle">
              <img
                src="@/assets/icons/close-icon.png"
                alt="切换科目"
                class="toggle-icon"
              />
            </button>
          </div>
        <div
          class="section"
          v-for="(item, index) in menuList"
          :key="index"
          :class="{ active: index === activeMenuIndex }"
          @click="activeMenuIndex = index"
        >
          {{ item }}
        </div>
      </aside>

      <!-- 中间内容区域 -->
      <main class="main">
        <div class="chat-module">
          <div class="chat-box" ref="chatBox">
            <div class="message-container">
              <div class="message-info">
                <img
                  class="avatar"
                  src="@/assets/ai.png"
                  alt="AI"
                />
                <div class="message-name">小明AI</div> <!-- 固定AI名字 -->
              </div>
              <div class="message-bubble ai">
                <div style="color: #5e6c84">你好，我是智能学习助理小明，我可以陪你答疑解惑，你可以尝试提问题。</div>
              </div>
            </div>
            <!-- 历史消息 -->
            <div v-for="(msg, index) in messages" :key="index" class="message-container" :class="msg.role">
              <!-- 头像+名字容器，根据角色添加不同布局类 -->
              <div class="message-info">
                <img
                  v-if="msg.role === 'ai'"
                  class="avatar"
                  src="@/assets/ai.png"
                  alt="AI"
                />
                <img
                  v-if="msg.role === 'user'"
                  class="avatar user-avatar"
                  src="@/assets/user.png"
                  alt="User"
                />
                <div v-if="msg.role === 'ai'" class="message-name">小明AI</div> <!-- 示例名字，可动态获取 -->
              </div>
              <div :class="['message-bubble', msg.role]" v-html="formatMessage(msg.text)"></div>
            </div>
            <!-- 当前流式响应 -->
            <div v-if="currentAIMessage" class="message-bubble ai typing">
              <div v-html="formatMessage(currentAIMessage)"></div>
            </div>
            <div v-if="isThinking && !currentAIMessage" class="message-bubble ai typing">
              小明正在思考中...
            </div>
          </div>
          <div class="input-area">
            <input
              v-model="question"
              type="text"
              placeholder="请输入你的问题..."
              @keydown.enter="handleConversation"
            />
            <button @click="handleConversation" class="send-image-btn">
              <img src="@/assets/icons/send.png" alt="发送" class="send-icon" />
            </button>
          </div>
        </div>

        <pre class="response">{{ conversationResponse }}</pre>
        <div class="error" v-if="conversationError">{{ conversationError }}</div>

        <!-- 资源推荐组件 -->
        <ResourceSection ref="resourceSection" :video-list="videoList" :vr-list="vrList" />
      </main>

      <!-- 右侧模块 -->
      <aside class="right-panel">
        <KnowledgeGraph @tag-click="onTagClick" />
        <LearningProgress :active-index="activeMenuIndex"/>
      </aside>
    </div>
  </div>
</template>

<script>
  import ResourceSection from '../../components/ResourceSection.vue'
  import KnowledgeGraph from '../../components/KnowledgeGraph.vue'
  import LearningProgress from '../../components/LearningProgress.vue'
  import jsonData from '../../assets/data/course.json';
  const { marked } = require('marked')

  export default {
    name: 'App',
    components: {
      ResourceSection,
      KnowledgeGraph,
      LearningProgress
    },
    data() {
      return {
        isSidebarOpen: true,
        activeMenuIndex: 0,
        menuList: [
          '液压与气压传动', '画法几何与机械制图', '机械设计', '互换性与测量技术基础',
          '机械原理', '机械制造技术基础', '工程材料', '汽车工程',
          '材料成型与加工', '冲压模具', '数控技术', '电气控制与PLC', '机械制造基础'
        ],
        question: '',
        messages: [],
        currentAIMessage: '',
        isThinking: false,
        videoList: [],
        vrList: [],
        sessionIds: {
          chat: null,
          vr: null,
          video: null
        },
        typingIndex: 0,
        typingText: '',
        conversationResponse:'',
        conversationError: ''
      };
    },
    methods: {
      toggleSidebar(){
        this.isSidebarOpen = !this.isSidebarOpen;
      },
      formatMessage(text) {
        if (!text) return '';
        let formatted = text
          .replace(/```json/g, '<pre class="code"><code>')
          .replace(/```/g, '</code></pre>');
        return marked(formatted.replace(/\n/g, '<br/>'));
      },
      scrollToBottom() {
        const box = this.$refs.chatBox;
        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      },
      async initSessions() {
        await this.createSession('chat', 'b444520806f011f08d170242ac130003');
        await this.createSession('vr', '270f19b806fa11f08dbf0242ac130003');
        await this.createSession('video', '24eedf9c143d11f0bbe60242ac130006');
      },
      async createSession(key, agentId) {
        const baseUrl = "http://111.14.215.17";
        const apiKey = "ragflow-UxMjljOTEyMDZmODExZjBiYjMwMDI0Mm";
        const params = '{"lang":"Chinese (Simplified)","file":"Who are you"}';

        try {
          const url = new URL(`${baseUrl}/api/v1/agents/${agentId}/sessions`);
          const headers = {
            Authorization: `Bearer ${apiKey}`,
            'Content-Type': 'application/json'
          };
          const response = await fetch(url, {
            method: 'POST',
            headers,
            body: params
          });
          const data = await response.json();
          this.sessionIds[key] = data.data.id;
        } catch (err) {
          console.error(`${key} session 初始化失败`, err);
        }
      },
      async handleConversation() {
        if (!this.question.trim()) return;

        const userText = this.question;
        // 添加用户消息前，先检查该消息是否已经存在（避免重复）
        if (!this.messages.some(msg => msg.text === userText && msg.role === 'user')) {
          this.messages.push({ role: 'user', text: userText });
          this.$nextTick(() => this.scrollToBottom())
        }
        this.question = '';
        this.isThinking = true;

        await Promise.all([
          this.requestAgent('chat', 'b444520806f011f08d170242ac130003', userText, true),
          this.requestAgent('vr', '270f19b806fa11f08dbf0242ac130003', userText, false),
          this.requestAgent('video', '24eedf9c143d11f0bbe60242ac130006', userText, false)
        ]);
      },
      async requestAgent(type, agentId, question, isStream) {
        const sessionId = this.sessionIds[type];
        if (!sessionId) return;

        try {
          const response = await fetch(`http://111.14.215.17/api/v1/agents/${agentId}/completions`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ragflow-UxMjljOTEyMDZmODExZjBiYjMwMDI0Mm'
            },
            body: JSON.stringify({ question, stream: isStream, session_id: sessionId })
          });

          if (isStream) {
            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            let latest = '';
            while (true) {
              const { done, value } = await reader.read();
              if (done) break;
              const chunk = decoder.decode(value);
              const lines = chunk.split('\n');
              console.log("lines:----------"+lines)
              for (let line of lines) {
                if (line.startsWith('data:')) {
                  try {
                    console.log("line:----------"+line)
                    const json = JSON.parse(line.slice(5).trim());
                    const answer = json.data.answer;
                    const reg = new RegExp(this.currentAIMessage, 'g');
                    const result = answer.replace(reg, '');
                    if (answer) latest = result;
                  } catch (e) {
                    console.warn('解析失败', e);
                  }
                }
              }
            }

            this.startTyping(latest);
          } else {
            const data = await response.json();

            // 去掉 JSON 中的 code块标记符
            const cleanAnswer = data.data.answer.replace(/```json/g, '').replace(/```/g, '');
            const parsedData = JSON.parse(cleanAnswer);

            if (type === 'vr') {
              this.vrList = parsedData.map(item => ({
                title: item['知识点'] || '',
                path: item['链接地址'] || '',
                img: item['图片地址'] || ''
              })).filter(item => item.title && item.path && item.img);
            } else if (type === 'video') {
              this.videoList = parsedData.map(item => ({
                title: item['知识点'] || '',
                path: item['视频地址'] || '',
                img: item['图片地址'] || ''
              })).filter(item => item.title && item.path && item.img);
            }
          }
        } catch (err) {
          console.error(`${type} 请求失败`, err);
          if (type === 'chat') this.conversationError = '对话请求失败，请稍后再试';
        } finally {
          if (type === 'chat') this.isThinking = false;
        }
      },
      startTyping(fullText) {
        this.currentAIMessage = '';
        this.typingIndex = 0;
        this.typingText = fullText;

        const typing = () => {
          if (this.typingIndex < this.typingText.length) {
            this.currentAIMessage += this.typingText[this.typingIndex];
            this.typingIndex++;
            this.$nextTick(() => this.scrollToBottom())
            setTimeout(typing, 20);
          } else {
            this.messages.push({ role: 'ai', text: this.currentAIMessage });
            this.currentAIMessage = '';
            this.typingText = '';
            this.$nextTick(() => this.scrollToBottom())
          }
        };

        typing();
      },
      onTagClick(tag) {
        this.question = tag;
        this.handleConversation();
      },
      resetResources() {
        const allVideo = [];
        const allVR = [];

        const data = this.allResourceData.data || [];

        data.forEach(course => {
          course.chapter.forEach(chap => {
            if (Array.isArray(chap.videos)) {
              chap.videos.forEach(video => {
                if (video.path && video.img) {
                  allVideo.push(video);
                }
              });
            }

            if (Array.isArray(chap.course)) {
              chap.course.forEach(vr => {
                if (vr.path && vr.img) {
                  allVR.push(vr);
                }
              });
            }
          });
        });

        this.videoList = allVideo;
        this.vrList = allVR;

        // 缓存一份初始完整数据，供搜索失败时 fallback 使用
        this.allVideoList = allVideo;
        this.allVRList = allVR;
      }
    },
    mounted() {
      this.initSessions();
      this.allResourceData = jsonData;
      this.resetResources();
    }
  };
</script>

<style scoped>

  /* 大屏幕布局：三栏 */
  .container {
    display: flex;
    flex-wrap: nowrap;
  }

  /* 中小屏：改为垂直布局 */
  @media (max-width: 1024px) {
    .container {
      flex-direction: column;
    }

    .sidebar, .right-panel {
      width: 100% !important;
    }

    .main {
      width: 100%;
      padding: 0 16px;
    }
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Noto Sans SC', sans-serif;
    background-color: #f5f6fa;
  }

  .header {
    background: url('~@/assets/bj.png') no-repeat center center;
    background-size: cover;
    height: 80px;
    display: flex;
    align-items: flex-end;
    padding: 0 40px 20px;
  }

  .logo-text {
    font-size: 28px;
    font-weight: bold;
    color: #377ef0;
  }

  .sidebar {
    text-align: center;
    margin: 10px;
    width: 296px;
    background: #ffffff;
    border-radius: 16px;
    padding: 10px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06); /* 卡片投影 */
  }

  .main {
    flex: 1;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
  }

  .right-panel {
    width: 296px;
  }

  .section {
    padding: 10px 24px;
    font-size: 18px;
    color: #222;
    line-height: 36px;
    cursor: pointer;
  }

  .section:hover {
    background-color: #f0f0f0;
  }

  .chat-module {
    margin-top: 10px;
    margin-bottom: 10px;
    background: #ffffff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06); /* 卡片投影 */
  }

  .chat-box {
    margin: 10px;
    max-height: 330px;
    min-height: 330px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    scrollbar-width: thin; /* Firefox 滚动条宽度（非 WebKit） */
    scrollbar-color: #2d85ed #f0f5ff; /* Firefox 滚动条颜色 */
  }

  .message-bubble {
    max-width: 40%;
    padding: 12px 16px;
    margin: 8px 0;
    border-radius: 12px;
    border: 1px solid #cfd8dc;
    line-height: 1.5;
    word-break: break-word;
  }
  .message-bubble.user {
    background: #daf1fd;
    align-self: flex-end;
    color: #5e6c84;
  }
  .message-bubble.ai {
    background: #fcfdff;
    align-self: flex-start;
    color: #5e6c84;
  }
  .typing {
    opacity: 0.8;
    font-style: italic;
  }
  .input-area {
    display: flex;
    gap: 12px;
  }
  .input-area input {
    flex: 1;
    padding: 10px;
    font-size: 16px;
  }
  .code {
    background: #f4f4f4;
    padding: 8px;
    border-radius: 6px;
    font-family: monospace;
    color: #222;
  }

  .message {
    font-size: 18px;
    color: #5ac684;
    margin-top: 20px;
  }

  .input-area {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background-color: #fff;
    border: 1px solid #cfd8dc;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  .input-area input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 16px;
    padding: 10px 14px;
  }

  .send-image-btn {
    background-color: transparent;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px; /* 根据图片大小调整 */
    height: 44px; /* 根据图片大小调整 */
  }

  .send-icon {
    width: 44px; /* 图片实际显示宽度 */
    height: 44px; /* 图片实际显示高度 */
    object-fit: contain; /* 保持图片比例 */
  }

  /* 原按钮样式覆盖（如果有冲突） */
  .input-area button {
    background-color: transparent; /* 清除原背景色 */
    padding: 0; /* 清除原内边距 */
    border: none; /* 清除原边框 */
  }

  .send-image-btn:hover {
    opacity: 0.9;
    transform: scale(1.05);
    transition: all 0.3s ease;
  }

  .send-image-btn:active {
    transform: scale(0.95);
  }

  /* === 响应式样式 === */
  @media (max-width: 1024px) {
    .container {
      flex-direction: column;
      padding: 16px;
    }

    .sidebar, .right-panel {
      width: 100%;
      margin-bottom: 16px;
    }

    .main {
      padding: 0;
      width: 100%;
    }

    .resource-container {
      flex-direction: column;
      gap: 32px;
    }

    .resource-box {
      width: 100%;
    }

    .chat-box {
      height: auto;
      min-height: 240px;
    }

    .input-area {
      flex-direction: column;
      align-items: stretch;
      border-radius: 16px;
    }

    .input-area input {
      font-size: 15px;
      padding: 8px 12px;
    }

    .input-area button {
      margin-top: 10px;
      font-size: 14px;
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .resource-scroll {
      gap: 12px;
    }

    .resource-item {
      flex: 0 0 180px;
    }

    .resource-caption {
      font-size: 14px;
      line-height: 1.5;         /* 建议设置行高，使文本布局更稳定 */
      overflow: hidden;         /* 隐藏溢出内容 */
      text-overflow: ellipsis;  /* 溢出时显示省略号 */
      display: -webkit-box;     /* 启用弹性盒模型（WebKit 内核） */
      -webkit-box-orient: vertical; /* 垂直排列子元素 */
      -webkit-line-clamp: 2;    /* 限制显示的最大行数（这里是 2 行） */
      white-space: normal;      /* 允许文本自动换行 */
      word-wrap: break-word;
    }

    .resource-nav button {
      width: 26px;
      height: 26px;
      font-size: 14px;
    }

    .resource-title {
      font-size: 20px;
    }

    .resource-header {
      font-size: 16px;
    }

    .message {
      font-size: 16px;
    }

    .section {
      font-size: 16px;
      padding: 8px 16px;
    }
  }

  @media (max-width: 1024px) {
    .right-panel {
      width: 100%;
      padding: 16px 0;
    }
  }

  .typing {
    opacity: 0.7;
    font-style: italic;
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0%, 100% { opacity: 0.7; }
    50% { opacity: 1; }
  }

  .section.active {
    background-color: #f6f7f9;
    color: #2780e8;
    font-weight: 500;
    border-radius: 10px;
  }
  /*markdown*/
  .message-bubble div {
    line-height: 1.6;
  }

  .message-bubble pre {
    background: #f6f8fa;
    padding: 10px;
    border-radius: 6px;
    overflow-x: auto;
    font-family: monospace;
  }

  .message-bubble code {
    background: #eee;
    padding: 2px 4px;
    border-radius: 4px;
    font-family: monospace;
  }

  .message-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    width: 100%;
  }

  /* AI 消息：左对齐 */
  .message-container.ai {
    align-items: flex-start;
  }

  /* 用户消息：右对齐 */
  .message-container.user {
    align-items: flex-end;
  }

  .message-info {
    display: flex;
    align-items: center;
    gap: 8px; /* 头像与名字间距 */
  }

  /* 用户头像样式（右对齐时头像在右侧，名字在左侧？不，需要名字在头像右侧，所以布局反转） */
  /* 正确做法：用户消息的 message-info 整体右对齐，头像在左，名字在右（视觉上在右侧） */
  .message-container.user .message-info {
    flex-direction: row; /* 保持头像→名字顺序 */
    justify-content: flex-end; /* 整体右对齐 */
  }

  .avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }

  .user-avatar {
    /* 用户头像可能需要调整边距，确保和AI对称 */
    margin-left: 8px; /* 当用户消息右对齐时，头像在右侧，左边距用于间距 */
  }

  .message-name {
    font-size: 18px;
    color: #000000;
  }

  /* 气泡样式优化 */
  .message-bubble {
    max-width: 400px;
    padding: 12px 16px;
    border-radius: 12px;
    line-height: 1.6;
  }

  .message-bubble.ai {
    background: #fcfdff;
    border: 1px solid #e0e8ff;
  }

  .message-bubble.user {
    background: #daf1fd;
    border: 1px solid #f0e0e8;
  }

  .sidebar-header {
    margin-bottom: 10px;
    height: 60px;
    border-radius: 10px;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    /* 背景图设置（仅标题栏） */
    background-image: url('~@/assets/icons/km.png');
  }

  .sidebar-title {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
  }

  .sidebar-toggle {
    background: none;
    border: none;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  .toggle-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .toggle-icon-open {
    width: 98px;
    height: 102px;
    object-fit: contain;
  }

  .sidebar-toggle:hover {
    opacity: 0.9;
    transform: scale(1.05);
    transition: all 0.3s ease;
  }

  .sidebar-toggle:active {
    transform: scale(0.95);
  }

  .sidebar-collapsed {
   display: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue